import React from "react";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";

export function PromocionesList({ promos, authAxios, onRefresh }) {
  const toggle = async (id) => {
    try {
      await authAxios.patch(`/marketing/promotions/${id}/toggle`);
      onRefresh();
    } catch {
      toast.error("Erro ao atualizar");
    }
  };

  return (
    <div className="space-y-2 pt-4 border-t">
      <h3 className="text-sm font-semibold">Gerenciar Promoções</h3>
      {promos.map(p => (
        <div key={p.id} className="flex items-center justify-between p-3 bg-card border border-border rounded-lg">
          <div className="flex-1 min-w-0">
            <p className="font-medium text-sm">{p.name}</p>
            <p className="text-xs text-muted-foreground">
              {p.discount_value}{p.discount_type === "percentage" ? "%" : "€"} • {p.uses || 0} usos
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Badge className={p.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}>
              {p.active ? "Ativa" : "Inativa"}
            </Badge>
            <Switch checked={p.active} onCheckedChange={() => toggle(p.id)} />
          </div>
        </div>
      ))}
    </div>
  );
}
